import {SearchTypeTypes} from '@aboutyou/legacy-tracking-sdk';
import {useCurrentPageType, usePathname, useSearch} from '@aboutyou/router';
import React, {memo, useEffect} from 'react';
import {useTrackSearch} from '../../trackingHooks/trackSearch';
import {useTracking} from '../../utils/utils';

const TrackSearch = () => {
  if (!process.browser) {
    return null;
  }

  return <StartTrackSearch />;
};

const StartTrackSearch = () => {
  const {getSearchEventParams, resetSearchEventParams} = useTracking();
  const trackSearch = useTrackSearch();
  const search = useSearch();
  const pathname = usePathname();
  const currentPageType = useCurrentPageType();

  // eslint-disable-next-line local-rules/too-complex-useeffects -- TODO: Cleanup complex useEffect https://aboutyou.atlassian.net/browse/ASFE-7605
  useEffect(() => {
    const searchEventParams = getSearchEventParams();

    /**
     * Prevent tracking on search pages to avoid an incorrect trigger before checking if the user will be redirected
     * "srp" searchType for this tracking event will be manually trigger on the legacy search pages, the logic should be moved here when those pages are moved to Tadarida
     */
    if (
      searchEventParams &&
      searchEventParams.shouldFire &&
      currentPageType !== 'search' &&
      currentPageType !== 'searchResults' &&
      currentPageType !== 'categoryLegacy' &&
      currentPageType !== 'brandLegacy'
    ) {
      const {
        searchName,
        searchTerm,
        searchTermCompleted,
        searchType: contextSearchType,
      } = searchEventParams;

      const searchType: SearchTypeTypes = (() => {
        if (contextSearchType) {
          return contextSearchType;
        }

        if (
          currentPageType &&
          ['brandShop', 'brandsOverview', 'category', 'story'].includes(
            currentPageType,
          )
        ) {
          return 'bi_search';
        }

        return 'url_manager';
      })();

      trackSearch({
        searchAction: 'submit',
        searchType,
        searchTerm,
        searchTermCompleted,
        searchName,
        searchDestination: pathname + search,
      });
      resetSearchEventParams();
    }
  }, [currentPageType, pathname, search]);

  return null;
};

const MemoizesTrackSearch = memo(TrackSearch);

export {MemoizesTrackSearch as TrackSearch};
